// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var MM_parser = require("../mm-utils/MM_parser.bs.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var FileLoader = require("../utils/FileLoader.bs.js");
var MM_context = require("../mm-utils/MM_context.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var MM_wrk_client = require("../worker/MM_wrk_client.bs.js");
var MM_wrk_editor = require("../worker/MM_wrk_editor.bs.js");
var MM_wrk_LoadCtx = require("../worker/MM_wrk_LoadCtx.bs.js");
var Expln_React_Row = require("@expln/utils/src/main/react-mui-components/Expln_React_Row.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var Expln_React_Modal = require("@expln/utils/src/main/react-components/Expln_React_Modal.bs.js");
var Belt_HashMapString = require("rescript/lib/js/belt_HashMapString.js");
var Expln_React_Column = require("@expln/utils/src/main/react-mui-components/Expln_React_Column.bs.js");
var JsxPPXReactSupport = require("rescript/lib/js/jsxPPXReactSupport.js");
var MM_wrk_ParseMmFile = require("../worker/MM_wrk_ParseMmFile.bs.js");
var Paper = require("@mui/material/Paper").default;
var Expln_utils_promise = require("@expln/utils/src/main/Expln_utils_promise.bs.js");
var Local_storage_utils = require("../ui-utils/Local_storage_utils.bs.js");
var Button = require("@mui/material/Button").default;
var AccordionSummaryStyled = require("../ui-utils/AccordionSummaryStyled.bs.js");
var Add = require("@mui/icons-material/Add").default;
var Accordion = require("@mui/material/Accordion").default;
var IconButton = require("@mui/material/IconButton").default;
var ExpandMore = require("@mui/icons-material/ExpandMore").default;
var AccordionDetails = require("@mui/material/AccordionDetails").default;
var MM_cmp_context_selector_single = require("./MM_cmp_context_selector_single.bs.js");

function createEmptySingleScope(id, srcType) {
  return {
          id: id,
          srcType: srcType,
          fileSrc: undefined,
          fileText: undefined,
          ast: undefined,
          allLabels: [],
          readInstr: /* ReadAll */0,
          label: undefined
        };
}

function setSrcType(ss, srcType) {
  return {
          id: ss.id,
          srcType: srcType,
          fileSrc: ss.fileSrc,
          fileText: ss.fileText,
          ast: ss.ast,
          allLabels: ss.allLabels,
          readInstr: ss.readInstr,
          label: ss.label
        };
}

function setFileSrc(ss, fileSrc) {
  return {
          id: ss.id,
          srcType: ss.srcType,
          fileSrc: fileSrc,
          fileText: ss.fileText,
          ast: ss.ast,
          allLabels: ss.allLabels,
          readInstr: ss.readInstr,
          label: ss.label
        };
}

function setFileText(ss, fileText) {
  return {
          id: ss.id,
          srcType: ss.srcType,
          fileSrc: ss.fileSrc,
          fileText: fileText,
          ast: ss.ast,
          allLabels: ss.allLabels,
          readInstr: ss.readInstr,
          label: ss.label
        };
}

function setAst(ss, ast) {
  return {
          id: ss.id,
          srcType: ss.srcType,
          fileSrc: ss.fileSrc,
          fileText: ss.fileText,
          ast: ast,
          allLabels: ss.allLabels,
          readInstr: ss.readInstr,
          label: ss.label
        };
}

function setAllLabels(ss, allLabels) {
  return {
          id: ss.id,
          srcType: ss.srcType,
          fileSrc: ss.fileSrc,
          fileText: ss.fileText,
          ast: ss.ast,
          allLabels: allLabels,
          readInstr: ss.readInstr,
          label: ss.label
        };
}

function setReadInstr(ss, readInstr) {
  return {
          id: ss.id,
          srcType: ss.srcType,
          fileSrc: ss.fileSrc,
          fileText: ss.fileText,
          ast: ss.ast,
          allLabels: ss.allLabels,
          readInstr: readInstr,
          label: ss.label
        };
}

function setLabel(ss, label) {
  return {
          id: ss.id,
          srcType: ss.srcType,
          fileSrc: ss.fileSrc,
          fileText: ss.fileText,
          ast: ss.ast,
          allLabels: ss.allLabels,
          readInstr: ss.readInstr,
          label: label
        };
}

function addSingleScope(st, defaultSrcType) {
  return {
          nextId: st.nextId + 1 | 0,
          expanded: st.expanded,
          singleScopes: Belt_Array.concat(st.singleScopes, [createEmptySingleScope(String(st.nextId), defaultSrcType)]),
          loadedContextSummary: st.loadedContextSummary
        };
}

function updateSingleScope(st, id, update) {
  return {
          nextId: st.nextId,
          expanded: st.expanded,
          singleScopes: st.singleScopes.map(function (ss) {
                if (ss.id === id) {
                  return Curry._1(update, ss);
                } else {
                  return ss;
                }
              }),
          loadedContextSummary: st.loadedContextSummary
        };
}

function setExpanded(st, expanded) {
  return {
          nextId: st.nextId,
          expanded: expanded,
          singleScopes: st.singleScopes,
          loadedContextSummary: st.loadedContextSummary
        };
}

function setLoadedContextSummary(st, loadedContextSummary) {
  return {
          nextId: st.nextId,
          expanded: st.expanded,
          singleScopes: st.singleScopes,
          loadedContextSummary: loadedContextSummary
        };
}

function getNameFromFileSrc(src) {
  if (src === undefined) {
    return ;
  }
  if (src.TAG === /* Local */0) {
    return src.fileName;
  }
  var match = src._0;
  var alias = match.alias;
  if (alias.trim() !== "") {
    return alias;
  } else {
    return match.url;
  }
}

function getSummary(st) {
  if (st.singleScopes.length === 1 && Belt_Option.isNone(Caml_array.get(st.singleScopes, 0).fileSrc)) {
    return "Empty MM context is loaded.";
  }
  var filesInfo = st.singleScopes.map(function (ss) {
        var name = Belt_Option.getWithDefault(getNameFromFileSrc(ss.fileSrc), "");
        var match = ss.readInstr;
        var readInstr;
        switch (match) {
          case /* ReadAll */0 :
              readInstr = "";
              break;
          case /* StopBefore */1 :
              readInstr = ", stopped before '" + Belt_Option.getWithDefault(ss.label, "") + "'";
              break;
          case /* StopAfter */2 :
              readInstr = ", stopped after '" + Belt_Option.getWithDefault(ss.label, "") + "'";
              break;
          
        }
        return name + readInstr;
      });
  return "Loaded: " + filesInfo.join("; ");
}

function makeActTerminate(modalRef, modalId, param) {
  MM_wrk_client.terminateWorker(undefined);
  Expln_React_Modal.closeModal(modalRef, modalId);
}

var webTypStr = MM_wrk_editor.mmFileSourceTypeToStr(/* Web */1);

function isScopeSame(singleScopes, srcs) {
  if (singleScopes.length === srcs.length) {
    return singleScopes.every(function (ss, i) {
                var srcDto = Caml_array.get(srcs, i);
                var ssFileSrc = ss.fileSrc;
                if (ssFileSrc === undefined) {
                  return false;
                }
                if (ssFileSrc.TAG === /* Local */0) {
                  return false;
                }
                if (srcDto.typ !== webTypStr || srcDto.url !== ssFileSrc._0.url || MM_wrk_editor.readInstrFromStr(srcDto.readInstr) !== ss.readInstr) {
                  return false;
                }
                var match = ss.readInstr;
                if (match === 0) {
                  return true;
                }
                var ssLabel = ss.label;
                if (ssLabel !== undefined) {
                  return ssLabel === srcDto.label;
                } else {
                  return false;
                }
              });
  } else {
    return false;
  }
}

function canLoadContext(srcs) {
  if (srcs.length > 0) {
    return srcs.every(function (src) {
                return src.typ === webTypStr;
              });
  } else {
    return false;
  }
}

function shouldReloadContext(singleScopes, srcs) {
  if (canLoadContext(srcs)) {
    return !isScopeSame(singleScopes, srcs);
  } else {
    return false;
  }
}

function parseMmFileForSingleScope(st, singleScopeId, modalRef) {
  var ss = st.singleScopes.find(function (ss) {
        return ss.id === singleScopeId;
      });
  if (ss !== undefined) {
    var src = ss.fileSrc;
    if (src !== undefined) {
      var text = ss.fileText;
      if (text !== undefined) {
        var name = Belt_Option.getExn(getNameFromFileSrc(src));
        var progressText = "Parsing " + name + "";
        return Expln_utils_promise.promise(function (rsv) {
                    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                return MM_react_common.rndProgress(progressText, 0, undefined, undefined);
                              })), (function (modalId) {
                            var onTerminate = function (param) {
                              return makeActTerminate(modalRef, modalId, param);
                            };
                            Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                    return MM_react_common.rndProgress(progressText, 0, onTerminate, undefined);
                                  }));
                            MM_wrk_ParseMmFile.beginParsingMmFile(text, (function (pct) {
                                    Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                            return MM_react_common.rndProgress(progressText, pct, onTerminate, undefined);
                                          }));
                                  }), (function (parseResult) {
                                    var st$1;
                                    if (parseResult.TAG === /* Ok */0) {
                                      var match = parseResult._0;
                                      var allLabels = match[1];
                                      var ast = match[0];
                                      var st$2 = updateSingleScope(st, ss.id, (function (__x) {
                                              return setAst(__x, {
                                                          TAG: /* Ok */0,
                                                          _0: ast
                                                        });
                                            }));
                                      st$1 = updateSingleScope(st$2, ss.id, (function (__x) {
                                              return setAllLabels(__x, allLabels);
                                            }));
                                    } else {
                                      var msg = parseResult._0;
                                      var st$3 = updateSingleScope(st, ss.id, (function (__x) {
                                              return setAst(__x, {
                                                          TAG: /* Error */1,
                                                          _0: msg
                                                        });
                                            }));
                                      st$1 = updateSingleScope(st$3, ss.id, (function (__x) {
                                              return setAllLabels(__x, []);
                                            }));
                                    }
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                    Curry._1(rsv, st$1);
                                  }));
                          }));
                  });
      }
      throw {
            RE_EXN_ID: MM_parser.MmException,
            _1: {
              msg: "fileText is not set for the mmSingleScope with id '" + singleScopeId + "'"
            },
            Error: new Error()
          };
    }
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "fileSrc is not set for the mmSingleScope with id '" + singleScopeId + "'"
          },
          Error: new Error()
        };
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Could not find an mmSingleScope with id '" + singleScopeId + "'"
        },
        Error: new Error()
      };
}

function parseMmFileForSingleScopeRec(mmScope, modalRef, ssIdx) {
  if (ssIdx === mmScope.singleScopes.length) {
    return Expln_utils_promise.promise(function (rslv) {
                Curry._1(rslv, {
                      TAG: /* Ok */0,
                      _0: mmScope
                    });
              });
  }
  var ss = Caml_array.get(mmScope.singleScopes, ssIdx);
  return Expln_utils_promise.promiseFlatMap(parseMmFileForSingleScope(mmScope, ss.id, modalRef), (function (mmScope) {
                var ss$1 = mmScope.singleScopes.find(function (s) {
                      return s.id === ss.id;
                    });
                if (ss$1 !== undefined) {
                  var match = ss$1.ast;
                  if (match !== undefined) {
                    if (match.TAG === /* Ok */0) {
                      return parseMmFileForSingleScopeRec(mmScope, modalRef, ssIdx + 1 | 0);
                    }
                    var msg = match._0;
                    return Expln_utils_promise.promise(function (rslv) {
                                Curry._1(rslv, {
                                      TAG: /* Error */1,
                                      _0: msg
                                    });
                              });
                  }
                  throw {
                        RE_EXN_ID: MM_parser.MmException,
                        _1: {
                          msg: "Could not parse MM file for ss.id = " + ss$1.id + ""
                        },
                        Error: new Error()
                      };
                }
                throw {
                      RE_EXN_ID: MM_parser.MmException,
                      _1: {
                        msg: "None == singleScopes->find(s => s.id == ss.id)"
                      },
                      Error: new Error()
                    };
              }));
}

function scopeIsEmpty(singleScopes) {
  if (singleScopes.length === 1) {
    return Belt_Option.isNone(Caml_array.get(singleScopes, 0).fileSrc);
  } else {
    return false;
  }
}

function loadMmContext(singleScopes, modalRef, showError) {
  return Expln_utils_promise.promise(function (rsv) {
              if (scopeIsEmpty(singleScopes)) {
                return Curry._1(rsv, {
                            TAG: /* Ok */0,
                            _0: MM_context.createContext(undefined, undefined, undefined)
                          });
              }
              var progressText = "Loading MM context";
              Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                          return MM_react_common.rndProgress(progressText, 0, undefined, undefined);
                        })), (function (modalId) {
                      var onTerminate = function (param) {
                        return makeActTerminate(modalRef, modalId, param);
                      };
                      Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                              return MM_react_common.rndProgress(progressText, 0, onTerminate, undefined);
                            }));
                      MM_wrk_LoadCtx.beginLoadingMmContext(singleScopes.map(function (ss) {
                                var stopBefore = ss.readInstr === /* StopBefore */1 ? ss.label : undefined;
                                var stopAfter = ss.readInstr === /* StopAfter */2 ? ss.label : undefined;
                                var label = Belt_Option.getWithDefault(stopBefore, Belt_Option.getWithDefault(stopAfter, Belt_Option.getWithDefault(Belt_Array.get(ss.allLabels, ss.allLabels.length - 1 | 0), "")));
                                var match = ss.ast;
                                var tmp;
                                if (match !== undefined) {
                                  if (match.TAG === /* Ok */0) {
                                    tmp = match._0;
                                  } else {
                                    throw {
                                          RE_EXN_ID: MM_parser.MmException,
                                          _1: {
                                            msg: "Cannot load an MM context from an empty or error ast."
                                          },
                                          Error: new Error()
                                        };
                                  }
                                } else {
                                  throw {
                                        RE_EXN_ID: MM_parser.MmException,
                                        _1: {
                                          msg: "Cannot load an MM context from an empty or error ast."
                                        },
                                        Error: new Error()
                                      };
                                }
                                return {
                                        ast: tmp,
                                        expectedNumOfAssertions: ss.allLabels.indexOf(label) + 1 | 0,
                                        stopBefore: stopBefore,
                                        stopAfter: stopAfter
                                      };
                              }), (function (pct) {
                              Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                      return MM_react_common.rndProgress(progressText, pct, onTerminate, undefined);
                                    }));
                            }), (function (ctx) {
                              if (ctx.TAG !== /* Ok */0 && showError) {
                                var msg = ctx._0;
                                Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                            return null;
                                          })), (function (modalId) {
                                        Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                                return React.createElement(Paper, {
                                                            style: {
                                                              padding: "10px"
                                                            },
                                                            children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                                                                      spacing: 1,
                                                                      children: Caml_option.some(null)
                                                                    }, "Error loading context:", React.createElement("pre", {
                                                                          style: {
                                                                            color: "red"
                                                                          }
                                                                        }, msg), React.createElement(Button, {
                                                                          onClick: (function (param) {
                                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                                            }),
                                                                          variant: "contained",
                                                                          children: "Ok"
                                                                        })))
                                                          });
                                              }));
                                      }));
                              }
                              Curry._1(rsv, ctx);
                              Expln_React_Modal.closeModal(modalRef, modalId);
                            }));
                    }));
            });
}

function loadMmFileText(modalRef, trustedUrls, onUrlBecomesTrusted, alias, url) {
  return Expln_utils_promise.promise(function (rslv) {
              FileLoader.loadFileWithProgress(modalRef, !trustedUrls.includes(url), onUrlBecomesTrusted, url, "Downloading MM file from \"" + alias + "\"", (function (text) {
                      Curry._1(rslv, {
                            TAG: /* Ok */0,
                            _0: text
                          });
                    }), (function (msg) {
                      Curry._1(rslv, {
                            TAG: /* Error */1,
                            _0: "An error occurred while downloading from \"" + alias + "\": " + Belt_Option.getWithDefault(msg, "") + "."
                          });
                    }), undefined, (function (param) {
                      Curry._1(rslv, {
                            TAG: /* Error */1,
                            _0: "Downloading from \"" + alias + "\" was terminated."
                          });
                    }), undefined);
            });
}

function loadMmFileTextForSingleScope(mmScope, modalRef, trustedUrls, onUrlBecomesTrusted, loadedTexts, ssIdx) {
  if (ssIdx === mmScope.singleScopes.length) {
    return Expln_utils_promise.promise(function (rslv) {
                Curry._1(rslv, {
                      TAG: /* Ok */0,
                      _0: mmScope
                    });
              });
  }
  var ss = Caml_array.get(mmScope.singleScopes, ssIdx);
  var match = ss.fileSrc;
  if (match !== undefined) {
    if (match.TAG === /* Local */0) {
      throw {
            RE_EXN_ID: MM_parser.MmException,
            _1: {
              msg: "Cannot load MM file text for a Local fileSrc."
            },
            Error: new Error()
          };
    }
    var match$1 = match._0;
    var url = match$1.url;
    var $$continue = function (text) {
      var mmScope$1 = updateSingleScope(mmScope, ss.id, (function (__x) {
              return setFileText(__x, text);
            }));
      return loadMmFileTextForSingleScope(mmScope$1, modalRef, trustedUrls, onUrlBecomesTrusted, loadedTexts, ssIdx + 1 | 0);
    };
    var text = Belt_HashMapString.get(loadedTexts, url);
    if (text !== undefined) {
      return $$continue(text);
    } else {
      return Expln_utils_promise.promiseFlatMap(loadMmFileText(modalRef, trustedUrls, onUrlBecomesTrusted, match$1.alias, url), (function (res) {
                    if (res.TAG === /* Ok */0) {
                      return $$continue(res._0);
                    }
                    var msg = res._0;
                    return Expln_utils_promise.promise(function (rslv) {
                                Curry._1(rslv, {
                                      TAG: /* Error */1,
                                      _0: msg
                                    });
                              });
                  }));
    }
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot load MM file text for a None fileSrc."
        },
        Error: new Error()
      };
}

function srcDtoToFileSrc(src, webSrcSettings) {
  if (src.typ !== webTypStr) {
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "Cannot convert a non-Web mmCtxSrcDto to a mmFileSource."
          },
          Error: new Error()
        };
  }
  var match = webSrcSettings.find(function (ws) {
        return ws.url === src.url;
      });
  var tmp;
  if (match !== undefined) {
    var alias = match.alias;
    tmp = alias.trim() !== "" ? alias : src.url;
  } else {
    tmp = src.url;
  }
  return {
          TAG: /* Web */1,
          _0: {
            alias: tmp,
            url: src.url
          }
        };
}

function makeMmScopeFromSrcDtos(modalRef, webSrcSettings, srcs, trustedUrls, onUrlBecomesTrusted, loadedTexts) {
  var mmScope = srcs.reduce((function (mmScope, src) {
          var mmScope$1 = addSingleScope(mmScope, /* Web */1);
          var ssId = Caml_array.get(mmScope$1.singleScopes, mmScope$1.singleScopes.length - 1 | 0).id;
          var mmScope$2 = updateSingleScope(mmScope$1, ssId, (function (__x) {
                  return setSrcType(__x, /* Web */1);
                }));
          var mmScope$3 = updateSingleScope(mmScope$2, ssId, (function (__x) {
                  return setFileSrc(__x, srcDtoToFileSrc(src, webSrcSettings));
                }));
          var mmScope$4 = updateSingleScope(mmScope$3, ssId, (function (__x) {
                  return setReadInstr(__x, MM_wrk_editor.readInstrFromStr(src.readInstr));
                }));
          return updateSingleScope(mmScope$4, ssId, (function (__x) {
                        return setLabel(__x, src.label);
                      }));
        }), {
        nextId: 0,
        expanded: false,
        singleScopes: [],
        loadedContextSummary: ""
      });
  return Expln_utils_promise.promiseFlatMap(loadMmFileTextForSingleScope(mmScope, modalRef, trustedUrls, onUrlBecomesTrusted, loadedTexts, 0), (function (res) {
                if (res.TAG === /* Ok */0) {
                  return parseMmFileForSingleScopeRec(res._0, modalRef, 0);
                }
                var msg = res._0;
                return Expln_utils_promise.promise(function (rslv) {
                            Curry._1(rslv, {
                                  TAG: /* Error */1,
                                  _0: msg
                                });
                          });
              }));
}

var defaultSrcTypeStrLocStorKey = "ctx-selector-default-src-type";

function MM_cmp_context_selector(props) {
  var onChange = props.onChange;
  var onUrlBecomesTrusted = props.onUrlBecomesTrusted;
  var webSrcSettings = props.webSrcSettings;
  var modalRef = props.modalRef;
  var match = React.useState(function () {
        return Belt_Option.getWithDefault(Local_storage_utils.locStorReadString(defaultSrcTypeStrLocStorKey), MM_wrk_editor.mmFileSourceTypeToStr(/* Web */1));
      });
  var setDefaultSrcTypeStrPriv = match[1];
  var setDefaultSrcTypeStr = function (defaultSrcTypeStr) {
    Local_storage_utils.locStorWriteString(defaultSrcTypeStrLocStorKey, defaultSrcTypeStr);
    Curry._1(setDefaultSrcTypeStrPriv, (function (param) {
            return defaultSrcTypeStr;
          }));
  };
  var defaultSrcType = Belt_Option.getWithDefault(MM_wrk_editor.mmFileSourceTypeFromStrOpt(match[0]), /* Web */1);
  var match$1 = React.useState(function () {
        return {
                nextId: 1,
                expanded: true,
                singleScopes: [createEmptySingleScope("0", defaultSrcType)],
                loadedContextSummary: ""
              };
      });
  var setState = match$1[1];
  var state = match$1[0];
  var match$2 = React.useState(function () {
        return state;
      });
  var setPrevState = match$2[1];
  var prevState = match$2[0];
  React.useEffect((function () {
          Curry._1(setState, (function (prev) {
                  return setLoadedContextSummary(prev, getSummary(prev));
                }));
        }), []);
  var actNewCtxIsReady = function (srcs, ctx) {
    Curry._1(setState, (function (st) {
            var st$1 = setLoadedContextSummary(st, getSummary(st));
            Curry._1(setPrevState, (function (param) {
                    return st$1;
                  }));
            return st$1;
          }));
    Curry._2(onChange, srcs, ctx);
  };
  var trustedUrls = webSrcSettings.filter(function (s) {
          return s.trusted;
        }).map(function (s) {
        return s.url;
      });
  var toggleAccordion = function (param) {
    Curry._1(setState, (function (prev) {
            return setExpanded(prev, !prev.expanded);
          }));
  };
  var rndSingleScopeSelectors = function (param) {
    var renderDeleteButton = state.singleScopes.length > 1 || Belt_Option.isSome(Caml_array.get(state.singleScopes, 0).fileSrc);
    return state.singleScopes.map(function (singleScope) {
                var match = singleScope.ast;
                var tmp;
                tmp = match !== undefined && match.TAG !== /* Ok */0 ? match._0 : undefined;
                return JsxPPXReactSupport.createElementWithKey(singleScope.id, MM_cmp_context_selector_single.make, {
                            modalRef: modalRef,
                            availableWebSrcs: webSrcSettings.filter(function (s) {
                                    return s.alias.trim().length > 0;
                                  }).map(function (s) {
                                  return {
                                          alias: s.alias,
                                          url: s.url
                                        };
                                }),
                            trustedUrls: trustedUrls,
                            onUrlBecomesTrusted: onUrlBecomesTrusted,
                            srcType: singleScope.srcType,
                            onSrcTypeChange: (function (srcType) {
                                if (state.singleScopes.length === 1) {
                                  setDefaultSrcTypeStr(MM_wrk_editor.mmFileSourceTypeToStr(srcType));
                                }
                                Curry._1(setState, (function (__x) {
                                        return updateSingleScope(__x, singleScope.id, (function (__x) {
                                                      return setSrcType(__x, srcType);
                                                    }));
                                      }));
                              }),
                            fileSrc: singleScope.fileSrc,
                            onFileChange: (function (src, text) {
                                var id = singleScope.id;
                                var st = updateSingleScope(state, id, (function (__x) {
                                        return setFileSrc(__x, src);
                                      }));
                                var st$1 = updateSingleScope(st, id, (function (__x) {
                                        return setFileText(__x, text);
                                      }));
                                Expln_utils_promise.promiseMap(parseMmFileForSingleScope(st$1, id, modalRef), (function (st) {
                                        Curry._1(setState, (function (param) {
                                                return st;
                                              }));
                                      }));
                              }),
                            parseError: tmp,
                            readInstr: singleScope.readInstr,
                            onReadInstrChange: (function (readInstr) {
                                Curry._1(setState, (function (__x) {
                                        return updateSingleScope(__x, singleScope.id, (function (__x) {
                                                      return setReadInstr(__x, readInstr);
                                                    }));
                                      }));
                              }),
                            label: singleScope.label,
                            onLabelChange: (function (labelOpt) {
                                Curry._1(setState, (function (__x) {
                                        return updateSingleScope(__x, singleScope.id, (function (__x) {
                                                      return setLabel(__x, labelOpt);
                                                    }));
                                      }));
                              }),
                            allLabels: singleScope.allLabels,
                            renderDeleteButton: renderDeleteButton,
                            onDelete: (function (param) {
                                Curry._1(setState, (function (__x) {
                                        var id = singleScope.id;
                                        var st_nextId = __x.nextId;
                                        var st_expanded = __x.expanded;
                                        var st_singleScopes = Belt_Array.keep(__x.singleScopes, (function (ss) {
                                                return ss.id !== id;
                                              }));
                                        var st_loadedContextSummary = __x.loadedContextSummary;
                                        var st = {
                                          nextId: st_nextId,
                                          expanded: st_expanded,
                                          singleScopes: st_singleScopes,
                                          loadedContextSummary: st_loadedContextSummary
                                        };
                                        if (st_singleScopes.length === 0) {
                                          return addSingleScope(st, defaultSrcType);
                                        } else {
                                          return st;
                                        }
                                      }));
                              })
                          });
              });
  };
  var rndAddButton = function (param) {
    var thereIsAtLeastOneValidSingleScope = state.singleScopes.some(function (singleScope) {
          var match = singleScope.ast;
          if (match !== undefined && match.TAG === /* Ok */0) {
            return true;
          } else {
            return false;
          }
        });
    if (thereIsAtLeastOneValidSingleScope) {
      return JsxPPXReactSupport.createElementWithKey("add-button", IconButton, {
                  onClick: (function (param) {
                      Curry._1(setState, (function (__x) {
                              return addSingleScope(__x, defaultSrcType);
                            }));
                    }),
                  children: Caml_option.some(React.createElement(Add, {}))
                });
    } else {
      return null;
    }
  };
  var applyChanges = function (state, showError) {
    if (scopeIsEmpty(state.singleScopes)) {
      return Expln_utils_promise.promise(function (rslv) {
                  Curry._1(setState, (function (param) {
                          return state;
                        }));
                  actNewCtxIsReady([], MM_context.createContext(undefined, undefined, undefined));
                  Curry._1(rslv, {
                        TAG: /* Ok */0,
                        _0: undefined
                      });
                });
    } else {
      return Expln_utils_promise.promiseMap(loadMmContext(state.singleScopes, modalRef, showError), (function (res) {
                    if (res.TAG !== /* Ok */0) {
                      return {
                              TAG: /* Error */1,
                              _0: res._0
                            };
                    }
                    var mmCtxSrcDtos = state.singleScopes.map(function (ss) {
                          var src = ss.fileSrc;
                          if (src !== undefined) {
                            if (src.TAG === /* Local */0) {
                              return {
                                      typ: MM_wrk_editor.mmFileSourceTypeToStr(/* Local */0),
                                      fileName: src.fileName,
                                      url: "",
                                      readInstr: MM_wrk_editor.readInstrToStr(ss.readInstr),
                                      label: Belt_Option.getWithDefault(ss.label, "")
                                    };
                            } else {
                              return {
                                      typ: MM_wrk_editor.mmFileSourceTypeToStr(/* Web */1),
                                      fileName: "",
                                      url: src._0.url,
                                      readInstr: MM_wrk_editor.readInstrToStr(ss.readInstr),
                                      label: Belt_Option.getWithDefault(ss.label, "")
                                    };
                            }
                          }
                          throw {
                                RE_EXN_ID: MM_parser.MmException,
                                _1: {
                                  msg: "ss.fileSrc is None"
                                },
                                Error: new Error()
                              };
                        });
                    Curry._1(setState, (function (param) {
                            return state;
                          }));
                    actNewCtxIsReady(mmCtxSrcDtos, res._0);
                    return {
                            TAG: /* Ok */0,
                            _0: undefined
                          };
                  }));
    }
  };
  props.reloadCtx.current = (function (srcs) {
      if (!shouldReloadContext(prevState.singleScopes, srcs)) {
        return Expln_utils_promise.promise(function (rslv) {
                    Curry._1(rslv, {
                          TAG: /* Ok */0,
                          _0: undefined
                        });
                  });
      }
      var loadedTexts = Belt_HashMapString.fromArray(prevState.singleScopes.map(function (ss) {
                    var match = ss.fileSrc;
                    if (match === undefined) {
                      return ;
                    }
                    if (match.TAG === /* Local */0) {
                      return ;
                    }
                    var text = ss.fileText;
                    if (text !== undefined) {
                      return [
                              match._0.url,
                              text
                            ];
                    }
                    
                  }).filter(Belt_Option.isSome).map(Belt_Option.getExn));
      return Expln_utils_promise.promiseFlatMap(makeMmScopeFromSrcDtos(modalRef, webSrcSettings, srcs, trustedUrls, onUrlBecomesTrusted, loadedTexts), (function (res) {
                    if (res.TAG === /* Ok */0) {
                      return applyChanges(res._0, false);
                    }
                    var msg = res._0;
                    return Expln_utils_promise.promise(function (rslv) {
                                Curry._1(rslv, {
                                      TAG: /* Error */1,
                                      _0: msg
                                    });
                              });
                  }));
    });
  var rndSaveButtons = function (param) {
    var thereAreNoChanges = scopeIsEmpty(state.singleScopes) && scopeIsEmpty(prevState.singleScopes) || Caml_obj.equal(state.singleScopes, prevState.singleScopes);
    if (thereAreNoChanges) {
      return null;
    }
    var scopeIsCorrect = state.singleScopes.every(function (ss) {
          var match = ss.ast;
          if (match === undefined) {
            return false;
          }
          if (match.TAG !== /* Ok */0) {
            return false;
          }
          var match$1 = ss.readInstr;
          if (match$1 !== 0) {
            return ss.label !== undefined;
          } else {
            return true;
          }
        });
    var scopeIsEmpty$1 = scopeIsEmpty(state.singleScopes);
    return React.createElement(Expln_React_Row.make, {
                children: Caml_option.some(React.createElement(Button, {
                          onClick: (function (param) {
                              Expln_utils_promise.promiseMap(applyChanges(state, true), (function (res) {
                                      if (res.TAG === /* Ok */0 && !scopeIsEmpty$1) {
                                        return Curry._1(setState, (function (__x) {
                                                      return setExpanded(__x, false);
                                                    }));
                                      }
                                      
                                    }));
                            }),
                          variant: "contained",
                          disabled: !scopeIsCorrect && !scopeIsEmpty$1,
                          children: "Apply changes"
                        }))
              });
  };
  return React.createElement(Accordion, {
              expanded: state.expanded,
              children: null
            }, React.createElement(AccordionSummaryStyled.make, {
                  onClick: toggleAccordion,
                  expandIcon: Caml_option.some(React.createElement(ExpandMore, {})),
                  children: state.loadedContextSummary
                }), React.createElement(AccordionDetails, {
                  children: React.createElement(Expln_React_Column.make, {
                        spacing: 2,
                        children: Caml_option.some(null)
                      }, rndSingleScopeSelectors(undefined), rndAddButton(undefined), rndSaveButtons(undefined))
                }));
}

var make = MM_cmp_context_selector;

exports.make = make;
/* webTypStr Not a pure module */
